import React from 'react';
import { IconContainer } from './IconContainer';

const BackIcon = (props) => {
    return (
        <IconContainer ariaLabel="back" {...props}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.0498 12.364L14.9998 7.414L13.5858 6L7.22183 12.364L13.5858 18.728L14.9998 17.314L10.0498 12.364Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { BackIcon };